export class ParamInserter {
  selectors = [];
  targetSelector = null;

  constructor(...selectors) {
    if (!selectors.length) {
      throw 'selectorを1つ以上指定する必要があります'
    }

    this.selectors = selectors
    this.targetSelector = selectors[0]
  }

  bind(scope) {
    const withScope = selector => scope ? `${scope} ${selector}` : selector

    this.selectors.forEach(selector => {
      $(withScope(selector)).on('focus', () => (this.targetSelector = selector))
    })

    $(withScope('.params option')).on('dblclick', event => {
      const param = `{{${event.target.value}}}`
      const target = document.querySelector(withScope(this.targetSelector))
      const sentence = target.value
      const len = sentence.length
      const startPos = target.selectionStart
      const endPos = target.selectionEnd

      const before = sentence.substr(0, startPos)
      const after = sentence.substr(endPos, len)
      const afterPos = startPos + param.length
      target.value = before + param + after
      target.setSelectionRange(afterPos, afterPos)
      target.focus()
    })
  }
}
